import { apiRequest } from '../../../api/client';
import type {
  BillingPlans,
  BillingStatus,
  PaymentTransactionListResponse,
  PaymentTransactionReceipt,
  PlanName,
  SubscriptionCreateResponse,
} from '../../../api/types';

// PARA-131 — тонкие обёртки над apiRequest (контракт PARA-119/PARA-130).
// Здесь только HTTP: интерпретация ответов живёт в lib/billingState.ts.

export async function fetchBillingStatus(): Promise<BillingStatus> {
  return apiRequest<BillingStatus>('/billing/me');
}

export async function fetchBillingPlans(): Promise<BillingPlans> {
  return apiRequest<BillingPlans>('/billing/plans');
}

export async function createSubscription(plan: PlanName): Promise<SubscriptionCreateResponse> {
  // AC-17 PARA-130: в теле передаётся ТОЛЬКО plan — ни цены, ни валюты, ни периода.
  return apiRequest<SubscriptionCreateResponse>('/billing/subscriptions', {
    method: 'POST',
    body: { plan },
  });
}

export async function cancelSubscription(): Promise<void> {
  return apiRequest<void>('/billing/subscriptions/cancel', { method: 'POST' });
}

// PARA-140 (AC-4/AC-5) — история платежей и квитанция. Все статусы, включая
// REFUNDED: backend фильтрации нет, UI показывает полную историю.

export async function fetchTransactions(
  limit: number,
  offset: number,
): Promise<PaymentTransactionListResponse> {
  return apiRequest<PaymentTransactionListResponse>(
    `/billing/transactions?limit=${limit}&offset=${offset}`,
  );
}

export async function fetchTransactionReceipt(
  transactionId: number,
): Promise<PaymentTransactionReceipt> {
  return apiRequest<PaymentTransactionReceipt>(`/billing/transactions/${transactionId}`);
}
